import { formatDate } from './formatDate';
import { getDaysAdded } from './getDaysAdded';
import { getUtcDate } from './getUtcDate';

export function getADayAfter(date, pattern = 'inverse-dashed') {
  const serverTimezone = process.env.DEFAULT_SERVER_TIMEZONE;
  const newDate = getDaysAdded(date, 1);
  const utcDate = getUtcDate(newDate, serverTimezone);

  return formatDate(utcDate, pattern);
}
